import { render, staticRenderFns } from "./Transacciones3D.vue?vue&type=template&id=627adf06&"
import script from "./Transacciones3D.vue?vue&type=script&lang=js&"
export * from "./Transacciones3D.vue?vue&type=script&lang=js&"
import style0 from "./Transacciones3D.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports